import { clearImageFields } from '$tablet-app/src/app/images/actions';
import { RecordWithImageFields } from '$tablet-app/src/app/images/types';
import { UserRole } from '@akin-home/amplify';
import { HasID } from '@akin-home/records';
import { UserModel } from '@akin-home/user';
import { useStateStore } from '../stores/useStateStore';

export const UserRoleLabels: Record<UserRole, string> = {
  [UserRole.manager]: 'Home manager',
  [UserRole.member]: 'Member',
};

export const setUserStockImage = <T extends RecordWithImageFields>(
  record: T,
  stock_image_key: string
): T => {
  const cleared_record = clearImageFields(record);

  return { ...cleared_record, profilePicture: stock_image_key };
};

export const excludeUserFromList = <T extends HasID>(
  users: T[] | undefined,
  user_id: string
): T[] => users?.filter((u) => u.id !== user_id) || [];

export const getCurrentUserID = () => {
  const user_id = useStateStore.getState().current_user_id;

  if (!user_id) {
    throw Error('user_id must be set');
  }

  return user_id;
};

export const getCurrentUser = () => useStateStore.getState().current_user;

/** This is the user data that will be passed to the chat context when a message is sent */
export const getUserDataForChatContext = (user: UserModel) => ({
  id: user.id,
  name: user.name,
  email: user.email,
  username: user.username,
  phoneNumber: user.phoneNumber,
  planManagerName: user.planManagerName,
  planManagerEmail: user.planManagerEmail,
  carerPhone: user.carerPhone,
  carerName: user.carerName,
  supportWorkerPhone: user.supportWorkerPhone,
  supportWorkerName: user.supportWorkerName,
});

export const getUserChatAppID = (user: UserModel) =>
  parseInt(user.chatApplicationId || '1');
